import config from '@/config';
function isContactsV1Enabled() {
    return config.CONTACTS_LEGACY_API_ENABLED;
}
export default isContactsV1Enabled;
